import * as stylex from "@stylexjs/stylex";
import { breakpoints, colors, layoutAreas } from "../../../materials/consts.stylex";
import { gridCenteredMaxWidthAreas } from "../../../materials/layout.stylex";
// `table`'s grid-area/grid-column are inert: its parent (`root`) never sets
// `display: grid` (only `{ areas }` is destructured from gridCenteredMaxWidth,
// never `{ grid }`), so there's no grid context for these to place against.
// Kept for fidelity with the original, but they have no visual effect.
export const stylexStyles = {
    table: {
        kJuA4N: "x1yedbjw",
        k9WMMc: "xdpxx8g",
        kXwgrk: "xdt5ytf",
        k1xSpc: "x78zum5",
        kjj79g: "xl56j7k",
        kGNEyG: "x6s0dn4",
        kaIpWk: "x1cum3z5",
        kGVxlE: "xhncdk2",
        kWkggS: "x12peec7",
        keoZOQ: "xdj266r xoap61l",
        kBCFzs: "x1lx81y2 xnwq165",
        $$css: true
    }
};
export const rowStyles = {
    rootHighlighted: {
        kWkggS: "xsgpxw3",
        $$css: true
    },
    row: {
        k1xSpc: "x78zum5",
        kMwMTN: "xjvpvmj",
        kt9PQ7: "xso031l",
        kfdmCh: "x1q0q8m5",
        kL6WhQ: "x10z52kc",
        kjj79g: "x1nhvcw1",
        kXwgrk: "x3ieub6 xdjzykv",
        kLKAdn: "x1y1aw1k x10oghhx",
        kpe85a: "xy13l1i xl09ye4",
        kGO01o: "x1l90r2v x1d2orad",
        kE3dHu: "x163pfp xto3oe7",
        $$css: true
    },
    rowLink: {
        kGzVvX: "x9v0ylq",
        k67Jb4: "x1lku1pv",
        kJuGS5: "x1277o0a",
        $$css: true
    },
    mainContent: {
        k1xSpc: "x78zum5",
        kXwgrk: "x1q0g3np",
        kGNEyG: "x7a106z x1fda2i5",
        kwnvtZ: "x1a02dak x8bzfl9",
        kzqmXN: "xh8yej3",
        ks0D6T: "x193iq5w xjc3kjr",
        keoZOQ: "x1xmf6yo xo1zb4t",
        k1K539: "x1e56ztr x16ko1ya",
        kayTVb: "x182iqb8 xljzpm6",
        $$css: true
    },
    mainContentPaddingRtl: {
        kE3dHu: "x1uhho1l xto3oe7",
        kpe85a: "x1xpa7k",
        $$css: true
    },
    mainContentPaddingLtr: {
        kpe85a: "x1xpa7k xl09ye4",
        kE3dHu: "x1uhho1l",
        $$css: true
    },
    linkArrow: {
        k1xSpc: "x78zum5",
        kjj79g: "x13a6bvl",
        kGNEyG: "x6s0dn4",
        kUk6DE: "x98rzlu",
        keoZOQ: "x1xmf6yo xo1zb4t",
        $$css: true
    },
    link: {
        kMwMTN: "x12klvby",
        kGuDYH: "xkpwil5",
        k63SB2: "x1xlr1w8",
        k1xSpc: "xt0psk2 x1gzydxp",
        kDPRdz: "xhr9w20",
        $$css: true
    },
    linkImgRtl: {
        koQZXg: "xj3b58b",
        km5ZXQ: "x1db2dqx",
        $$css: true
    },
    linkImgLtr: {
        koQZXg: "xet2fuk",
        km5ZXQ: "x1yf7rl7",
        $$css: true
    },
    linkImg: {
        k1xSpc: "x1rg5ohu",
        kmuXW: "x2lah0s",
        kzqmXN: "xvy4d1p",
        kZKoxP: "xxk0z11",
        $$css: true
    }
};
export const sectionStyles = {
    root: {
        kBCFzs: "x1uq3dmu",
        kMwMTN: "x1mqxbix",
        $$css: true
    },
    content: {
        kzqmXN: "xh8yej3",
        kGO01o: "x18d9i69",
        $$css: true
    },
    contentRtl: {
        k9WMMc: "x1hr2gdg",
        $$css: true
    },
    contentLtr: {
        k9WMMc: "xdpxx8g",
        $$css: true
    }
};
